import * as React from 'react';

import { replacePhoneNumbers } from '../utils';
import { useRuntimeSetting } from '../../../hooks/useRuntimeSetting';

export const useHiddenMessagePhones = ({
  messageUserId,
  isOutcoming,
  onClick,
}: {
  messageUserId: number;
  isOutcoming: boolean;
  onClick: () => void;
}): {
  replacePhoneNumbers: (text: string) => string | (string | React.ReactElement)[];
} => {
  const [isPhonesHidden, setIsPhonesHidden] = React.useState<boolean>(true);

  const isHiddenMessagePhonesEnabled = useRuntimeSetting<boolean>('frontend-chats.hiddenMessagePhones.Enabled', false);
  const hiddenMessagePhonesUserIds = useRuntimeSetting<number[]>('frontend-chats.hiddenMessagePhonesUserIds', []);

  const onMessagePhonesClick = React.useCallback(() => {
    if (isPhonesHidden) {
      onClick();
    }
    setIsPhonesHidden(false);
  }, [isPhonesHidden, onClick]);

  React.useEffect(() => {
    if (isHiddenMessagePhonesEnabled && messageUserId && hiddenMessagePhonesUserIds.includes(messageUserId)) {
      setIsPhonesHidden(true);

      return;
    }

    setIsPhonesHidden(false);
  }, [messageUserId, isHiddenMessagePhonesEnabled, hiddenMessagePhonesUserIds]);

  const replacePhoneNumbersCallback = React.useCallback(
    (text: string) => {
      return replacePhoneNumbers({
        text,
        isOutcoming,
        isPhonesHidden,
        onClick: onMessagePhonesClick,
      });
    },
    [isOutcoming, isPhonesHidden, onMessagePhonesClick],
  );

  return {
    replacePhoneNumbers: replacePhoneNumbersCallback,
  };
};
